<template>
  <div class="align-items-center text-center">
    <div style="display: flex; justify-content: center; align-items: center">
      <h5
        style="
          margin-bottom: 10px;
          margin-top: 10px;
          font-weight: bold;
          font-size: 16px;
        "
      >
        ¡Refiere
      </h5>
      <!-- <v-lazy-image
        :src="require('../assets/img/Saludsa/saludsa_logo.png')"
        style="background: white; width: 130px"
      /> -->
      <v-lazy-image
        :src="this.$store.state.darkMode ? photoDark : photo"
        style="background: none; width: 130px; padding: 10px 0"
      />
      <h5
        style="
          margin-bottom: 10px;
          margin-top: 10px;
          font-weight: bold;
          font-size: 16px;
        "
      >
        !
      </h5>
    </div>
    <h5
      style="
        margin: 10px auto;
        font-size: 12px;
        color: #333333;
        width: 85%;
        text-align: center;
      "
    >
      Por favor ingresa el nombre de tu referido. <br />
      Copia el mensaje personalizado para enviarlo por
      <span style="text-decoration: underline; font-weight: 600">Whatsapp</span>
      y registre su interés.
    </h5>
  </div>

  <form role="form" autocomplete="off" @submit.prevent="onSubmit">
    <div class="row formContainer">
      <div
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style="margin-bottom: 10px"
      >
        <label
          for="example-text-input"
          class="form-control-label"
          style="font-weight: bold; font-size: 12px"
          >Nombres y apellidos
        </label>
        <input
          required
          placeholder="Nombres y apellidos"
          class="form-control col-lg-12"
          type="text"
          autocomplete="off"
          v-model="displayName"
        />
      </div>

      <!-- <div
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style="margin-bottom: 10px"
      >
        <label
          for="example-text-input"
          class="form-control-label"
          style="font-weight: bold; font-size: 12px"
          >Número Celular (*):</label
        >

        <MazPhoneNumberInput
          type="tel"
          default-country-code="EC"
          :country-locale="phoneCountryLocale"
          :preferred-countries="preferredPhoneCountries"
          style="width: 100%"
          no-example
          required
          show-code-on-list
          size="sm"
          v-model="phoneNumber"
          :class="this.$store.state.darkMode ? 'dark' : ''"
          @update="results = $event"
          :translations="{
            countrySelector: {
              placeholder: 'Código',
              error: 'Elija un pais',
            },
            phoneInput: {
              placeholder: 'Nro. celular',
              example: 'Ejemplo:',
            },
          }"
        />
      </div> -->

      <div style="justify-content: flex-end; display: flex; margin: 20px 0 0 0">
        <button
          id="btn_submit"
          class="btn btn-primary"
          :disabled="isDisabled"
          style="align-self: flex-end"
        >
          Copiar
        </button>
      </div>
    </div>
  </form>
</template>

<script>
/*eslint-disable */

import ArgonSwitch from "../components/ArgonSwitch.vue";
import {
  PREFERRED_PHONE_COUNTRIES,
  PHONE_COUNTRY_LOCALE,
} from "@/constants/phoneCountries";

export default {
  name: "Venta",
  components: { ArgonSwitch },
  props: ["tokenAuth"],
  data() {
    // const datos_json = JSON.parse(this.$store.state.user);
    const datos_json = JSON.parse(localStorage.getItem("userData"));

    return {
      phoneCountryLocale: PHONE_COUNTRY_LOCALE,
      preferredPhoneCountries: PREFERRED_PHONE_COUNTRIES,
      isDisabled: false,
      displayName: null,
      phoneNumber: null,
      userId: datos_json.userId,
      promoCode: datos_json.promoCode,
      referer: datos_json.displayName,
      photo: require("../assets/img/Saludsa/saludsa_logo2.png"),
      photoDark: require("../assets/img/Saludsa/logo_saludsa_blanco.png"),
    };
  },
  methods: {
    copyField(fieldValue) {
      let name = "";
      name = this.displayName;
      if (navigator.clipboard) {
        navigator.clipboard
          .writeText(fieldValue)
          .then(() => {
            if (name) {
              this.$toast.success(`Enlace para ${name} copiado exitosamente.`, {
                position: "top-right",
                max: 10,
              });
            } else {
              this.$toast.success(`Enlace copiado exitosamente.`, {
                position: "top-right",
                max: 10,
              });
            }
          })
          .catch((err) => {
            console.error("No se pudo copiar el campo: ", err);
            this.$toast.error("Falla al copiar el campo.", {
              position: "top-right",
              max: 10,
            });
          });
      } else {
        console.error("Clipboard API not available.");
        this.$toast.error("Clipboard functionality not available.", {
          position: "top-right",
          max: 10,
        });
      }
    },
    onSubmit() {
      this.copyField(
        `Hola 🙋🏻‍♂️  *${this.displayName}* ¿Cómo estás?, *${this.referer.trim()}* te está invitando a contratar los mejores planes médicos del Ecuador con *Saludsa* la Empresa Más Grande de Medicina Prepagada de Ecuador. ¡Déjanos tus datos en el siguiente enlace y te contactaremos pronto! https://referidos.saludsa.com/venta/${this.promoCode}`
      );
      this.closeModal();

      // document.getElementById("btn_submit").innerHTML =
      //   '<i class="fas fa-spinner fa-pulse"></i>  Enviando';

      // this.isDisabled = true;

      // const jsonData = {
      //   userId: this.userId,
      //   referer: this.referer,
      //   promoCode: this.promoCode,
      //   prospectName: this.displayName,
      //   prospectPhone: this.phoneNumber,
      //   tokenAuth: this.tokenAuth,
      // };

      // this.$https
      //   .post("/leads/sendMessageToProspect", jsonData)
      //   .then((response) => {
      //     document.getElementById("btn_submit").innerHTML = "Enviar";
      //     this.isDisabled = false;
      //     if (response.data.code == 200) {
      //       this.$toast.success(response.data.message, {
      //         position: "top-right",
      //         max: 10,
      //       });
      //       this.closeModal();
      //     }
      //   })
      //   .catch((error) => {
      //     if (error.data.code == 401) {
      //       this.$toast.error(error.data.message, {
      //         position: "top-right",
      //         max: 10,
      //       });
      //       document.getElementById("btn_submit").innerHTML = "Enviar";
      //       this.isDisabled = false;

      //       if (response.data.code == 401) {
      //         localStorage.removeItem("userData");
      //         this.$store.state.user = "";

      //         this.$router.push({ name: "auth-login" });
      //       }
      //     } else {
      //       document.getElementById("btn_submit").innerHTML = "Enviar";
      //       this.isDisabled = false;

      //       this.$toast.error(
      //         "Ocurrió un error inesperado" + error.data.message,
      //         {
      //           position: "top-right",
      //           max: 10,
      //         }
      //       );
      //     }
      //   });
    },
    closeModal() {
      this.$eventBus.emit("reiniciarFormVenta");
      this.$eventBus.emit("closeModalSendLink");
    },
  },

  computed: {},
  watch: {
    results(newValue) {
      if (newValue.isValid) {
        this.phoneNumber = newValue.e164;
        this.hasPhone = true;

        // this.checkPhone();
      } else {
        this.hasPhone = false;
      }
    },
    displayName() {
      this.displayName = this.displayName.toUpperCase();
    },
    identityVerified(newValue, oldValue) {
      if (newValue !== oldValue) {
      }
    },
  },
  mounted() {
    // this.cargarScript();
  },
  created() {},
  beforeUnmount() {},
};
</script>

<style scoped>
.switchContainer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 16px 0 10px 0;
  gap: 12px;
}

.title {
  position: absolute;
  top: 0;
}
.switchContainer button.active {
  background-color: #0c75ba !important;
  color: white !important;
}

.switchContainer button {
  background-color: white !important;
  color: #0c75ba;
}

.formContainer {
  width: 100%;
}

@media (min-width: 1200px) {
  .formContainer {
    width: auto;
  }
}

@media (min-width: 1025px) and (max-width: 1200px) {
  .formContainer {
    width: auto;
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .formContainer {
    width: auto;
  }
}

@media (min-width: 100px) and (max-width: 767px) {
  .formContainer {
    width: auto;
  }
}

.resultContainer {
  width: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-bottom: 20px;
}
</style>
